import React from 'react'
import { Redirect } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './customerDisplay.css'
import SearchCustomerDisplay from './SearchCustomerDisplay'

export default function CustomerDisplay() {
  const hasCustomerDisplayPermission = useValidatePermission(
    VAPermissions.settingsCustomerDisplay
  )

  if (!hasCustomerDisplayPermission) {
    return <Redirect to={ROUTES.home} />
  }

  return (
    <>
      <Navigation />
      <div
        className="customer-display-container"
        data-testid="container-customer-display">
        <div className="customer-display-header">
          <h1 className="customer-display-title">
            {t('SETTINGS_T.CUSTOMER_DISPLAY.TITLE')}
          </h1>
        </div>
        <SearchCustomerDisplay />
      </div>
    </>
  )
}
